import { dataHooks } from '../../../../libs/dataHooks';

export const simpleMenuDropdownDataHooks = dataHooks<{
  itemLink: { id: string };
}>('simple-menu-dropdown');
